import React, { useRef, useState } from "react"
import { Pause, Play } from "phosphor-react"

const BAR_HEIGHTS = [
  8, 8, 8, 18, 24, 24, 14, 22, 20, 18, 12, 10, 18, 14, 20, 23, 21, 8, 8, 8, 20, 20, 23, 21, 8, 8, 8,
]

interface Props {
  voiceNoteUrl?: string | null
  playable?: boolean
}

export const MessageAttachmentAudio: React.FC<Props> = ({ voiceNoteUrl, playable = true }) => {
  const audioRef = useRef<HTMLAudioElement>(null)
  const [playing, setPlaying] = useState(false)
  const canPlay = playable && !!voiceNoteUrl

  const toggle = () => {
    const audio = audioRef.current
    if (!audio) return
    if (playing) audio.pause()
    else audio.play().catch(() => setPlaying(false))
  }

  const Icon = playing ? Pause : Play

  return (
    <div className="flex w-full items-center justify-between gap-6 rounded-md bg-neutral-200 p-4">
      {canPlay && (
        <audio
          ref={audioRef}
          src={voiceNoteUrl}
          preload="none"
          onPlay={() => setPlaying(true)}
          onPause={() => setPlaying(false)}
        />
      )}
      <div className="flex h-6 items-center gap-1 overflow-hidden">
        {BAR_HEIGHTS.map((h, i) => (
          <div key={i} className="w-2 rounded-full bg-base-black" style={{ height: `${h}px` }} />
        ))}
      </div>
      <button
        type="button"
        onClick={toggle}
        disabled={!canPlay}
        className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-base-black"
        aria-label={playing ? "Pause voice note" : "Play voice note"}
      >
        <Icon size={20} weight="fill" className="text-base-white" />
      </button>
    </div>
  )
}
